import axios from "axios";

let cancelToken;

export function getCancelToken() {
  if (cancelToken) {
    cancelToken.cancel("Canceled due to new request");
  }
  cancelToken = axios.CancelToken.source();
  return cancelToken.token;
}
